// LoRa time-on-air, per Semtech's SX127x/SX126x datasheet formula, with the
// Meshtastic firmware's framing constants (src/mesh/RadioInterface.h, read
// 2026-09-11): 16 preamble symbols, explicit header, CRC on.
//
// Low data rate optimization is assumed on when the symbol time exceeds
// 16 ms, RadioLib's automatic rule. The firmware file read did not state it,
// so this is the one unverified constant; it moves airtime by under 10%.

export interface LoraParams {
  bwHz: number
  sf: number
  /** Coding rate denominator, 5..8 for 4/5..4/8. */
  cr: number
  payloadBytes: number
  preambleSymbols?: number
  explicitHeader?: boolean
  crc?: boolean
  /** Explicit override; omit for the automatic rule. */
  lowDataRateOptimize?: boolean
}

export const MESHTASTIC_PREAMBLE_SYMBOLS = 16
export const MESHTASTIC_HEADER_BYTES = 16
export const MAX_LORA_PAYLOAD_BYTES = 255

export function symbolTimeS(bwHz: number, sf: number): number {
  return 2 ** sf / bwHz
}

/** RadioLib's rule: optimize when a symbol lasts longer than 16 ms. */
export function ldroAuto(bwHz: number, sf: number): boolean {
  return symbolTimeS(bwHz, sf) > 0.016
}

export function timeOnAirS(p: LoraParams): number {
  const preamble = p.preambleSymbols ?? MESHTASTIC_PREAMBLE_SYMBOLS
  const ih = (p.explicitHeader ?? true) ? 0 : 1
  const crc = (p.crc ?? true) ? 1 : 0
  const de = (p.lowDataRateOptimize ?? ldroAuto(p.bwHz, p.sf)) ? 1 : 0
  const tSym = symbolTimeS(p.bwHz, p.sf)
  const tPreamble = (preamble + 4.25) * tSym
  const numerator = 8 * p.payloadBytes - 4 * p.sf + 28 + 16 * crc - 20 * ih
  const denominator = 4 * (p.sf - 2 * de)
  const payloadSymbols = 8 + Math.max(Math.ceil(numerator / denominator) * (p.cr - 4 + 4), 0)
  return tPreamble + payloadSymbols * tSym
}
